export const focalInputStyles = {
	borderRadius: "2px",
	border: "1px",
	borderColor: "gray.400",
	".chakra-input__right-addon": {
		backgroundColor: "transparent",
		border: "none",
		borderRadius: "none",
		fontSize: "13px",
		color: "primary.500",
	},
	".chakra-numberinput__field": {
		border: "none !important",
		boxShadow: "none !important",
		fontSize: "13px",
	},
};

export const selectStyles = {
	".chakra-select": {
		background: "none",
	},
};
